(
    function (skyward, $)
    {
        "use strict";
        var init = function (selector)
        {
            var jqSelector = $(selector);
            var startDate = jqSelector.find("#UpdateMultipleActionDetailStatusesStartDate #StartDate");
            var endDate = jqSelector.find("#UpdateMultipleActionDetailStatusesEndDate #EndDate");

            startDate.blur(function () { changeEndDate(startDate, endDate); });
            endDate.blur(function () { changeStartDate(startDate, endDate); });
        };

        var changeEndDate = function (startDate, endDate)
        {
            var startDateValue = skyward.controls.getValue(startDate);
            var endDateValue = skyward.controls.getValue(endDate);

            if (startDateValue > endDateValue)
            {
                skyward.controls.setValue(endDate, startDateValue);
            }
        };

        var changeStartDate = function (startDate, endDate)
        {
            var startDateValue = skyward.controls.getValue(startDate);
            var endDateValue = skyward.controls.getValue(endDate);

            if (endDateValue < startDateValue)
            {
                skyward.controls.setValue(startDate, endDateValue);
            }
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);